import { useState } from 'react';
import CreateDiscountServices from 'features/DigitalAccount/DiscountCode/CreateDiscount/services/CreateDiscountServices';

function useProductsList() {
  const [productsList, setProductsList] = useState([]);
  const [productsLoading, setProductsLoading] = useState(false);

  const numberTester = new RegExp(/^[0-9]+$/);

  const getProductsList = async (val) => {
    if (val?.length >= 2) {
      setProductsLoading(true);
      try {
        const q = {
          query: null, // TODO: Debounce
          id: null,
          size: 10,
          offset: 0,
        };
        q[numberTester.test(val) ? 'id' : 'query'] = val;
        const result = await CreateDiscountServices.getProducts(q);
        const data = result.result;
        let list = [];
        list = data.map((val) => ({
          name: val.name,
          id: val.entityId,
          label: `${val.name} - ${val.entityId}`,
          value: val.entityId,
        }));
        setProductsList(list);
      } catch (e) {
        console.log('e :', e);
      }

      setProductsLoading(false);
    }
  };
  return { productsList, getProductsList, productsLoading };
}

export { useProductsList };
